export default __webpack_public_path__ + "static/media/patient.78fbb9be.png";